import { NOTIFICATION_SHOW, NOTIFICATION_DISMISS, NOTIFICATION_CLEAR } from './actionTypes'

const defaultDismissTime = 3000

/**
 * @description Publish a notification. if `dismissAfter` is set,
 * the notification will be auto dismissed after the given period.
 * @param {Object} notif - Object containing
 * @param {Object} notif.kind - Kinda of notification (success, warning, failure)
 * @param {Object} notif.message - Notification message
 * @param {Object} notif.dismissAfter - Time after which to dismiss notification (default time set in constants)
 */
// One timer per notification, so showing the same message again restarts its clock
const timers = {}

export const showNotification = notif => {
	const payload = Object.assign({}, notif)
	// The same message shares one id: repeating it refreshes the toast instead of stacking a copy
	if (!payload.id) {
		payload.id = payload.type + ':' + payload.message
	}
	return dispatch => {
		dispatch({ type: NOTIFICATION_SHOW, payload })

		clearTimeout(timers[payload.id])
		timers[payload.id] = setTimeout(() => {
			delete timers[payload.id]
			dispatch({
				type: NOTIFICATION_DISMISS,
				payload: payload.id
			})
		}, payload.dismissAfter || defaultDismissTime)
	}
}

export const showSuccess = message => showNotification({ type: 'success', message })

export const showError = message => showNotification({ type: 'error', message })

/**
 * @description Dismiss a notification by the given id.
 * @param {Number} id - notification id
 */
export const dismissNotification = payload => ({
	type: NOTIFICATION_DISMISS,
	payload
})

/**
 * @description Clear all notifications
 */
export const clearNotifications = () => ({ type: NOTIFICATION_CLEAR })
